export const mongoExplorerAllSchemas = "/mongo_explorer/all_schemas";
